import { Button } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { DebouncedSearchInput } from './DebouncedSearchInput.js';

/**
 * The header actions the Studios and Games pages build the same way: the desktop search box
 * (below `sm`, `MobileFilters` carries search instead, so this hides there), the page's own
 * "New …" button — its label and target differ per page, so it is passed in whole — and
 * "Pull all", which always targets every environment column the grid behind it shows.
 */
export const MatrixPageActions = ({
    isMobile,
    searchPlaceholder,
    search,
    onSearchChange,
    newButton,
    pulling,
    onPullAll,
}: {
    isMobile: boolean;
    searchPlaceholder: string;
    search: string;
    onSearchChange: (value: string) => void;
    newButton: ReactNode;
    pulling: boolean;
    onPullAll: () => void;
}) => (
    <>
        {!isMobile && (
            <DebouncedSearchInput
                w={240}
                placeholder={searchPlaceholder}
                value={search}
                onChange={onSearchChange}
                aria-label="Search"
            />
        )}
        {newButton}
        <Button
            variant="default"
            leftSection={<IconRefresh size={15} stroke={1.7} />}
            loading={pulling}
            onClick={onPullAll}
        >
            Pull all
        </Button>
    </>
);
